<!--
 * @Desc: 学校新闻
   标签类名，使用-进行分割命名，如page-home、item-form
   标签id，使用小驼峰规则命名，如homeId、itemId
   变量名，使用小驼峰规则命名，如publicPath、wxCode
 * @Author: 赵佳明
 * @Date: 2023-01-30 09:11:04
 * @LastEditors: wanglidong 王立冬
 * @LastEditTime: 2023-06-06 09:49:33
 * Copyright (c) 2023 山木枝(河北)技术服务有限公司, All Rights Reserved. 
-->
<template>
    <div class="page-news-detail">
        <!-- 菜单 -->
        <menuCommon :active="$route.query.active"></menuCommon>
        <!-- 内容区 -->
        <BreadCrumb :objectData="objectData"></BreadCrumb>
        <section class="news-detail">
            <div class="container">
                <div class="detail-hold">
                    <div class="time-adress">{{ detailData.publish_at ? '时间：'+ timestampToTime(detailData.publish_at,1) : '' }}　　　{{ detailData.address ? '地点：'+detailData.address : '' }}　　　{{ detailData.source ? '来源：'+detailData.source : '' }}</div>
                    <div class="detail-title">{{ detailData.title }}</div>
                    <div class="detail-html" v-html="detailData.content"></div>
                    <!-- <img src="../../public/statics/images/SchoolNews/detail.png"> -->
                </div>
                <div class="recommend-list">
                    <LastRecommend
                        :recommendData="recommendData"
                    ></LastRecommend>
                </div>
            </div>
        </section>
        <!-- 页脚 -->
        <footerCommon></footerCommon>
    </div>
</template>

<script>
import utils from "@/api/Utils.js"
import menuCommon from "./../components/Common/Menu.vue";
import footerCommon from "./../components/Common/Footer.vue";
import BreadCrumb from "./../components/Common/BreadCrumb.vue";
import RecommendedRead from "./../components/Common/RecommendedRead.vue";
import MenuVertical from "./../components/Common/MenuVertical.vue";
import LastRecommend from "./../components/Common/LastRecommend.vue";
export default {
    name: "home",
    data() {
        return {
            recommendData: {},
            detailData:'',
            // 栏目详情
            cateData:'',
            // 面包屑展示数据
            objectData: {
                title: "",
                navArray: [
                ],
                thu:''
            },
            // 顶部图片
            imageUrl: require("../../public/statics/images/Banner/banner1.jpg"),
        };
    },
    components: {
        menuCommon,
        footerCommon,
        BreadCrumb,
        RecommendedRead,
        MenuVertical,
        LastRecommend,
    },
    watch:{
        $route(val){
            if(this.$route.query.active) {
                this.cateDetail()
            }
            this.articleDetail()
        }
    },
    created() {
        if(this.$route.query.active) {
            this.cateDetail()
        }
        this.articleDetail()
    },
    mounted() {
        $("html,body").scrollTop(0);
    },
    beforeDestroy() {},
    methods: {
        // 格式化时间
        timestampToTime(timestamp, type){
            return utils.timestampToTime(timestamp, type)
        },
        // 栏目详情 面包屑展示
        cateDetail(){
            let that = this
            that.$api.index.cateDetail({id:this.$route.query.active}).then((res) => {
                if (res.code == 200) {
                    that.cateData = res.result
                    that.objectData.title = that.cateData.name
                    that.objectData.navArray = that.cateData.breadcrumb
                    that.objectData.thu = that.cateData.thumb
                }
            })
        },
        // 新闻详情
        articleDetail(){
            let that = this
            that.$api.index.articleDetail({id:this.$route.query.id}).then((res) => {
                if (res.code == 200) {
                    // console.log(res.result)
                    that.detailData = res.result
                }
            })
        },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.page-news-detail {
    background: #f0f2f5 no-repeat top center;
}
/*  */
.news-detail .container{
    display: flex;
    background: #ffffff;
    margin-bottom: 60px;
    padding-bottom: 30px;
    margin-top: 20px;
}
.news-detail .container .detail-hold{
    flex: 1;
}
.news-detail .container .detail-hold .time-adress{
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 0px;
    line-height: 16px;
    color: rgba(51, 51, 51, 1);
    padding-left: 20px;
    margin-top: 20px;
    margin-bottom: 16px;
}
.news-detail .container .detail-hold .detail-title{
    font-size: 26px;
    font-weight: 500;
    letter-spacing: 0px;
    line-height: 27px;
    color: rgba(51, 51, 51, 1);
    padding-left: 20px;
}
.news-detail .container .detail-hold .detail-html{
    padding: 20px;
}
.news-detail .container .recommend-list{
    width: 394px;
    background: #ffffff;
    padding-left: 50px;
    padding-top: 16px;
}
</style>